import { uniq } from "lodash";

export interface ProductVariationFormParsed {
    name1: string;
    name2: string;
    variations1: string[];
    variations2: string[];
}

function splitString(strs: string): string[] {
    return uniq(strs.split(",")
                .map((v:string) => v.trim())
                .filter((v:string) => !!v && v.length))
}

export class ProductVariationFormModel {
    name1: string = "";
    name2: string = "";
    variation1: string = "";
    variation2: string = "";

    getInfoParsed(): ProductVariationFormParsed {        
        let variations1:string[] = []
        let variations2:string[] = []
        
        if (this.variation1) {
            variations1 = splitString(this.variation1)
        }

        if (this.variation2) {
            variations2 = splitString(this.variation2)
        }

        return {
            name1: this.name1,
            name2: this.name2,
            variations1,
            variations2,
        }
    }
}
